// @core/api/endpoints/audittrail/verify_chain_integrity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VerifyChainIntegrityRequest,
  VerifyChainIntegrityResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Verify chain integrity
 * Verifies the integrity of the audit hash chain by recomputing hashes and comparing with stored values. Reports any tampered or missing records.
 */
export async function VerifyChainIntegrity(
  chain_id: string,
  data: VerifyChainIntegrityRequest,
  options?: RequestOptions
): Promise<VerifyChainIntegrityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/chains/:chain_id/verify`;
  requestPath = requestPath.replace(':chain_id', encodeURIComponent(chain_id));
  const requestOptions = options;
  return client.post<VerifyChainIntegrityResponse>(requestPath, data, requestOptions);
}
